import React from "react";
import styles from "./checkBox.module.css";
export const TimeSlot = ({
  timeSlotdata,
  timeSlotCheckbox,
  timeSlotChecked,
}) => {
  return (
    <div className={styles.timeSlotCheckBoxes}>
      {timeSlotdata?.map((item) => {
        const isSelected = timeSlotChecked === item.id;

        return (
          <div className={styles.timeSlotContainer} key={item.id}>
            <div
              className={`
                ${styles.timeSlotCheckBox}
                ${isSelected ? styles.selectedItem : ""}
              `}
            >
              <label>
                <input
                  type="checkbox"
                  onChange={() => timeSlotCheckbox(item.id)}
                  checked={isSelected}
                />
                <span>{item.value}</span>
              </label>
            </div>
          </div>
        );
      })}
    </div>
  );
};
